var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLawyerAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#57595a",
    d: "M-.03 16.908h13.398l-1.781-4.719H9.836c-.932 1.33-2.27 3.184-2.27 3.184H5.77s-1.338-1.853-2.27-3.184h-1.75z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#57595a",
    d: "M1.964 8.099a5.413 5.413 0 0 1-.706-2.675 5.417 5.417 0 0 1 5.41-5.41 5.417 5.417 0 0 1 5.411 5.41c0 .939-.244 1.864-.706 2.675-.851 1.494-4.172 6.089-4.313 6.284h-.783c-.14-.195-3.461-4.79-4.313-6.284zM6.67 2.267A3.156 3.156 0 0 0 3.516 5.42a3.156 3.156 0 0 0 3.153 3.152A3.156 3.156 0 0 0 9.82 5.42 3.156 3.156 0 0 0 6.67 2.267z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#57595a",
    d: "M8.196 6.949a2.16 2.16 0 0 1-3.058 0 2.16 2.16 0 0 1 0-3.058 2.16 2.16 0 0 1 3.058 0 2.16 2.16 0 0 1 0 3.058z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLawyerAddress);
export default __webpack_public_path__ + "static/media/icon-lawyer-address.6d2244eb.svg";
export { ForwardRef as ReactComponent };